import moment from 'moment';
import config from 'config';
import { isNumber } from 'lodash';
import { convertCostsFromTourPlanner } from './cost';

const {
  scenario: {
    vehicle,
    times: [{ value }],
  },
  shortTimeFormat,
} = config;

export function getVRPTimes(tourPlanner) {
  const defaultTimes = {
    start: moment(value.start, shortTimeFormat),
    end: moment(23, shortTimeFormat),
  };

  if (!tourPlanner) return defaultTimes;

  const end = tourPlanner.time.value.end !== 24 ? tourPlanner.time.value.end : '23:55';
  return {
    start: moment(tourPlanner.time.value.start, shortTimeFormat),
    end: moment(end, shortTimeFormat),
  };
}

export function getVRPVehicleDefinition(tourPlanner, isImperial, vehicleEntry) {
  const def = { ...vehicle };
  if (!tourPlanner) return def;
  const source = vehicleEntry || tourPlanner.vehicles[0];
  def.costs = convertCostsFromTourPlanner({ ...source.costs, isImperial });

  def.id = source.id;
  def.profile = source.profile;
  def.amount = isNumber(source.amount) ? source.amount : source.vehicleIds.length;
  def.capacity = source.capacity;

  return def;
}
